"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagsElement = void 0;

var TagsComponent_1 = require("../Component/TagsComponent");
/**
 * `TagsComponent` for the `PolylineRegion` class.
 */


var TagsElement = /*#__PURE__*/function (_TagsComponent_1$Tags) {
  _inherits(TagsElement, _TagsComponent_1$Tags);

  /**
   * Creates a new `TagsElement` object.
   * @param paper - The `Snap.Paper` object to draw on.
   * @param paperRect - The parent bounding box for created component.
   * @param regionData - The `RegionData` object shared across components. Used also for initial setup.
   * @param tags - The `TagsDescriptor` object presenting colors and names for region tags.
   * @param styleId - The unique css style id for region.
   * @param styleSheet - The regerence to the stylesheet object for rules insection.
   * @param tagsUpdateOptions - The settings for redrawing tags.
   */
  function TagsElement(paper, paperRect, regionData, tags, styleId, styleSheet, tagsUpdateOptions) {
    var _this;

    _classCallCheck(this, TagsElement);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TagsElement).call(this, paper, paperRect, regionData, tags, styleId, styleSheet, tagsUpdateOptions));

    _this.buildOn(paper, tags);

    return _this;
  }
  /**
   * Redraws the componnent.
   */


  _createClass(TagsElement, [{
    key: "redraw",
    value: function redraw() {
      var _this2 = this;

      var pointsData = [];
      this.regionData.points.forEach(function (p) {
        pointsData.push(p.x, p.y);
      });
      var size = TagsElement.DEFAULT_SECONDARY_TAG_SIZE;
      var cx = this.x + this.width / 2;
      var cy = this.y - size - 5;
      window.requestAnimationFrame(function () {
        _this2.primaryTagBoundRect.attr({
          x: _this2.x,
          y: _this2.y,
          width: _this2.width,
          height: _this2.height
        });

        _this2.primaryTagPolyline.attr({
          points: pointsData.toString()
        }); // Secondary Tags


        if (_this2.secondaryTags && _this2.secondaryTags.length > 0) {
          var length = _this2.secondaryTags.length;

          for (var i = 0; i < length; i++) {
            var stag = _this2.secondaryTags[i];
            var x = cx + (2 * i - length + 0.5) * size;
            stag.attr({
              x: x,
              y: cy
            });
          }
        }
      });
    }
    /**
     * Inits style maps.
     */

  }, {
    key: "initStyleMaps",
    value: function initStyleMaps(tags) {
      var _this3 = this;

      if (tags !== null) {
        if (tags.primary !== null) {
          this.styleMap = [{
            rule: ".".concat(this.styleId, " .primaryTagBoundRectStyle"),
            style: "fill: ".concat(tags.primary.colorShadow, ";\n                                stroke: ").concat(tags.primary.colorAccent, ";")
          }, {
            rule: ".regionStyle.selected.".concat(this.styleId, " .primaryTagBoundRectStyle"),
            style: "fill: ".concat(tags.primary.colorHighlight, ";")
          }, {
            rule: ".".concat(this.styleId, ":hover .primaryTagBoundRectStyle"),
            style: "fill: ".concat(tags.primary.colorHighlight, ";")
          }, {
            rule: ".".concat(this.styleId, " .primaryTagPolylineStyle"),
            style: "stroke: ".concat(tags.primary.colorPure, ";")
          }, {
            rule: ".regionStyle.".concat(this.styleId, " .anchorStyle"),
            style: "stroke:".concat(tags.primary.colorDark, ";\n                                fill: ").concat(tags.primary.colorPure)
          }, {
            rule: ".regionStyle.".concat(this.styleId, ":hover .anchorStyle"),
            style: "stroke:#fff;"
          }, {
            rule: ".regionStyle.".concat(this.styleId, " .anchorStyle.ghost"),
            style: "fill: var(--default-color-ghost);"
          }];
          this.styleLightMap = [{
            rule: ".".concat(this.styleId, " .primaryTagBoundRectStyle"),
            style: "fill: none;\n                                stroke: ".concat(tags.primary.colorAccent, ";")
          }, {
            rule: ".".concat(this.styleId, " .primaryTagPolylineStyle"),
            style: "stroke: ".concat(tags.primary.colorPure, ";\n                                stroke-width: 3px;")
          }, {
            rule: ".regionStyle.".concat(this.styleId, " .anchorStyle"),
            style: "stroke:".concat(tags.primary.colorDark, ";\n                                fill: ").concat(tags.primary.colorPure, ";\n                                stroke-width: 3px;")
          }, {
            rule: ".regionStyle.".concat(this.styleId, ":hover .anchorStyle"),
            style: "stroke:#fff;"
          }, {
            rule: ".regionStyle.".concat(this.styleId, " .anchorStyle.ghost"),
            style: "fill: var(--default-color-ghost);\n                                stroke-width: 0px;"
          }, {
            rule: ".regionStyle.".concat(this.styleId, " .secondaryTagStyle"),
            style: "opacity:0.25;"
          }];
        } else {
          this.styleMap = [];
          this.styleLightMap = [{
            rule: ".".concat(this.styleId, " .primaryTagBoundRectStyle"),
            style: "fill: none;\n                                stroke: var(--default-color-accent);"
          }, {
            rule: ".".concat(this.styleId, " .primaryTagBoundRectStyle"),
            style: "fill: none;"
          }, {
            rule: ".".concat(this.styleId, " .primaryTagPolylineStyle"),
            style: "stroke-width: 3px;"
          }, {
            rule: ".regionStyle.".concat(this.styleId, " .anchorStyle"),
            style: "stroke-width: 3px;"
          }, {
            rule: ".regionStyle.".concat(this.styleId, " .anchorStyle.ghost"),
            style: "fill: var(--default-color-ghost);"
          }];
        }

        if (tags.secondary !== null && tags.secondary !== undefined) {
          tags.secondary.forEach(function (tag) {
            var rule = {
              rule: ".secondaryTagStyle.secondaryTag-".concat(tag.name),
              style: "fill: ".concat(tag.colorAccent, ";")
            };

            _this3.styleMap.push(rule);

            _this3.styleLightMap.push(rule);
          });
        }
      }
    }
    /**
     * Internal function to recreate tag labels.
     */

  }, {
    key: "rebuildTagLabels",
    value: function rebuildTagLabels() {
      var _this4 = this;

      // Clear secondary tags -> redraw from scratch
      var _iterator = _createForOfIteratorHelper(this.secondaryTags),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var tag = _step.value;
          tag.remove();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.secondaryTags = []; // If there are tags assigned

      if (this.tags) {
        if (this.tags.primary !== undefined && this.tags.primary !== null) {// Primary Tag
        } // Secondary Tags


        if (this.tags.secondary && this.tags.secondary.length > 0) {
          var length = this.tags.secondary.length;

          var _loop = function _loop(i) {
            var stag = _this4.tags.secondary[i];
            var s = TagsElement.DEFAULT_SECONDARY_TAG_SIZE;
            var x = _this4.x + _this4.boundRect.width / 2 + (2 * i - length + 1) * s - s / 2;
            var y = _this4.y - s - 5;

            var tagel = _this4.paper.rect(x, y, s, s);

            window.requestAnimationFrame(function () {
              tagel.addClass("secondaryTagStyle");
              tagel.addClass("secondaryTag-".concat(stag.name));
            });

            _this4.secondaryTagsNode.add(tagel);

            _this4.secondaryTags.push(tagel);
          };

          for (var i = 0; i < length; i++) {
            _loop(i);
          }
        }
      }
    }
    /**
     * Internal function to create tag labels
     * @param paper - The `Snap.Paper` object to draw on.
     * @param tags - The `TagsDescriptor` object defining tags.
     */

  }, {
    key: "buildOn",
    value: function buildOn(paper, tags) {
      this.primaryTagNode = paper.g();
      this.primaryTagBoundRect = paper.rect(this.x, this.y, this.boundRect.width, this.boundRect.height);
      this.primaryTagBoundRect.addClass("primaryTagBoundRectStyle");
      var pointsData = [];
      this.regionData.points.forEach(function (p) {
        pointsData.push(p.x, p.y);
      });
      this.primaryTagPolyline = paper.polyline(pointsData);
      this.primaryTagPolyline.addClass("primaryTagPolylineStyle");
      this.regionData.points.forEach(function (p) {
        pointsData.push(p.x, p.y);
      });
      this.primaryTagNode.add(this.primaryTagBoundRect);
      this.primaryTagNode.add(this.primaryTagPolyline);
      this.secondaryTagsNode = paper.g();
      this.secondaryTagsNode.addClass("secondatyTagsLayer");
      this.secondaryTags = [];
      this.node.add(this.primaryTagNode);
      this.node.add(this.secondaryTagsNode);
      this.initStyleMaps(tags);
      this.updateTags(tags, this.tagsUpdateOptions);
    }
  }]);

  return TagsElement;
}(TagsComponent_1.TagsComponent);

exports.TagsElement = TagsElement;
/**
 * Default (visual) radius for primary tag.
 */

TagsElement.DEFAULT_PRIMARY_TAG_RADIUS = 3;
/**
 * Default (visual) size for secondary tag boxes.
 */

TagsElement.DEFAULT_SECONDARY_TAG_SIZE = 6;
/**
 * Default (visual) vertical shift for secondary tag boxes.
 */

TagsElement.DEFAULT_SECONDARY_TAG_DY = 6;